import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import {fetchUserIssuesDetails} from "../../../../store/user-issue-details/actions";
import styles from './issue-descripton.module.scss'

function IssueDescription({ issueId }) {
	const dispatch = useDispatch();
	const { data, loading } = useSelector((state) => state.UserIssuesDetails);

	const systemName = (name) => {
    const lowerName = name?.toLowerCase();

    switch (lowerName) {
      case 'win':
        return 'Windows';

      case ('mac'):
        return 'MacOS';

      case ('cros'):
        return 'Chrome OS';

      case ('lin'):
        return 'Linux';

      default:
        return name;
    }
  };

	useEffect(() => {
		if (issueId) {
			dispatch(fetchUserIssuesDetails(issueId));
		}
	}, [dispatch, issueId]);
	const firstCityAndCountry = (data && data?.location?.length > 0) && `${data?.location[0].city || '-'}, ${data?.location[0]?.country || '-'}`;

	return (
		<div className={styles.issueDescription}>
			<div className={styles.issueDescriptionTop}>
				<div>
					<p className={styles.issueDescriptionTitle}>Reported Date</p>
					<p className={styles.issueDescriptionValue}>{data?.createdAt}</p>
				</div>
				<div>
					<p className={styles.issueDescriptionTitle}>Location</p>
					<p className={styles.issueDescriptionValue}>{firstCityAndCountry || '-'}</p>
				</div>
				<div className={styles.issueDescriptionReference}>
					<p className={styles.issueDescriptionTitle}>Full Details</p>
					<p className={styles.issueDescriptionValue}>
						<Link to={`/admin/user-status/${data.userId}`}>{data?.email}</Link>
					</p>
				</div>
				{data?.app && (
					<div>
						<p className={styles.issueDescriptionTitle}>Application</p>
						<p className={styles.issueDescriptionValue}>{data.app}</p>
					</div>
				)}
			</div>
			{(data?.userDevice || data?.email) && (
				<div className={styles.issueDescriptionTop}>
					{data?.userDevice?.serialNumber && (<div>
						<p className={styles.issueDescriptionTitle}>Device Serial Number</p>
						<p className={styles.issueDescriptionValue}>{data.userDevice.serialNumber}</p>
					</div>)}
					{data?.userDevice?.operatingSystem && (<div>
						<p className={styles.issueDescriptionTitle}>Device Operating System</p>
						<p className={styles.issueDescriptionValue}>{systemName(data.userDevice.operatingSystem)}</p>
					</div>)}
					{data?.email && (<div>
						<p className={styles.issueDescriptionTitle}>Email</p>
						<p className={styles.issueDescriptionValue}>{data.email}</p>
					</div>)}
				</div>
			)}
			{data?.description && (
				<div className={styles.issueDescriptionBottom}>
					<div>
						<p className={styles.issueDescriptionTitle}>Reported Problem</p>
						<p className={styles.issueDescriptionValue}>{data?.description}</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default IssueDescription;
